import { z } from "zod";

import { THEME } from "../../components/ui/ThemeToggler/theme.types";

export const USER_ROLES = {
  admin: "admin",
  super_admin: "super_admin",
  moderator: "moderator",
  user_manager: "user_manager",
  basic: "basic",
  pro: "pro",
  reviewer: "reviewer",
  // Investor vetting (006): must ship in the same release as the backend
  // seed + backfill — after the backfill essentially every user holds
  // `investor` or `fundraiser`, and unknown roles fail schema validation.
  sales: "sales",
  investor: "investor",
  fundraiser: "fundraiser",
} as const;

export const userRoleSchema = z.nativeEnum(USER_ROLES);

export const userAppSettingsSchema = z.object({
  theme: z.nativeEnum(THEME),
});

export const userSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  role: userRoleSchema,

  email: z.string().email(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),

  appSettings: userAppSettingsSchema,

  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const userTokenSchema = z.object({
  accessToken: z.string().min(1),
  expiresAt: z.number(),
});

export type TUserToken = z.infer<typeof userTokenSchema>;

export type TUser = z.infer<typeof userSchema>;

export type TUpdateUserRequestPayload = RecursivePartial<TUser>;

export type TUpdateUserResponsePayload = TUser;

export type TUpdateProfileRequestPayload = {
  first_name?: string;
  last_name?: string;
  password?: string;
  phone_number?: string;
};

export type TRequestEmailChangePayload = {
  new_email: string;
};

export type TProfileData = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  email_verified: boolean;
  phone_verified: boolean;
  two_factor_enabled: boolean;
  status_id: number;
  auth_provider: string;
  phone_number?: string;
  last_login?: string;
};

export type TProfileResponsePayload = {
  code: number;
  message: string;
  data: TProfileData;
};

export type TRole = {
  role_id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
};

export type TRolesResponsePayload = {
  code: number;
  message: string;
  data: TRole[];
};
